.spw-card-content {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 12px 24px 24px 24px;
  z-index: 5;

  &__tag {
    position: absolute;
    top: -25px;
    left: 25px;
    padding: 6px 10px;
    border-radius: 4px 4px 0px 0px;
    background: var(--spw-ds-white);
    color: var(--spw-ds-primary);
    font-size: 15px;
    font-weight: 700;

    :host(.--no-image) & {
      position: relative;
      top: 0;
      left: 0;
      padding: 0;
      margin-bottom: 15px;
    }
  }

  &__date {
    margin-bottom: 7px;
    font-size: 15px;
    font-weight: 300;
    color: var(--spw-color-themes-grey-grey-600);
  }
}
